import { request } from "./request";

const BASE_URL = "/api/questionnaire";

export default {
  async fetch(qnaireId) {
    return await request(`${BASE_URL}/${qnaireId}`);
  },

  async answer(qnaireId, answer, useAlternative = false) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${qnaireId}`,
      data: useAlternative ? { alternative: true } : { answer },
    });
  },

  async skipQuestion(qnaireId) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${qnaireId}`,
      data: { skip: true },
    });
  },

  async back(qnaireId) {
    return await request({
      method: "POST",
      url: `${BASE_URL}/${qnaireId}/back`,
    });
  },

  async restart(qnaireId) {
    return await request({
      method: "PUT",
      url: `${BASE_URL}/${qnaireId}/restart`,
    });
  },

  async fetchAnswers() {
    return await request(`${BASE_URL}/answers`);
  },
};
